/*
 * NewTreatmentPage Messages
 *
 * This contains all the text for the NewTreatmentPage container.
 */

import { defineMessages } from "react-intl";

export const scope = "app.containers.NewTreatmentPage";

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: "This is the NewTreatmentPage container!",
  },
  appointment: {
    id: `${scope}.appointment`,
    defaultMessage: "Appointment",
  },
  firstHeader: {
    id: `${scope}.firstHeader`,
    defaultMessage: "Plan a new appointment - treatment by Refrezh KPT member",
  },
  firstHeaderEditing: {
    id: `${scope}.firstHeaderEditing`,
    defaultMessage: "Edit appointment - treatment by Refrezh KPT member",
  },
});
